import { TextField } from "@goodgamestudios/createjs-utilities";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { Poker2Model } from "../../../model/Poker2Model";
import { AbstractTeaser } from "./common/AbstractTeaser";
import { TeaserTextsVO } from "./common/TeaserTextsVO";
import { TeaserVO } from "./common/TeaserVO";

import MovieClip = createjs.MovieClip;

export class XmasTeaser extends AbstractTeaser {
    private _txtTitle: TextField;
    private _btnOk: MovieClip;
    protected _btnShop: MovieClip;
    private _tf_table: TextField;
    private _tf_tableType: TextField;
    private _tf_lobby: TextField;
    private _tf_freezOut: TextField;

    constructor(featureId: number, teaserMc: MovieClip, teaserVO: TeaserVO) {
        super(featureId, teaserMc, teaserVO);
    }

    protected buildHook(): void {
        this._txtTitle = this._teaserMc.txt_title;

        this._btnOk = this._teaserMc.btn_ok;
        this._btnShop = this._teaserMc.btn_shop;

        this._teaserMc.content.mouseChildren = false;
        this._tf_lobby = this._teaserMc.content.tf_lobby;
        this._tf_tableType = this._teaserMc.content.tf_tableType;
        this._tf_freezOut = this._teaserMc.content.tf_freezeOut;
        this._tf_table = this._teaserMc.content.tf_table;
    }

    public fillTexts(vo: TeaserTextsVO): void {
        super.fillTexts(vo);

        this._txtTitle.text = vo.titleStr;

        //
        this._tf_lobby.text = Poker2Model.languageData.getTextById("lobby_tournament_title");
        this._tf_tableType.text = Poker2Model.languageData.getTextById("lobby_tournamentTyp");
        this._tf_freezOut.text = Poker2Model.languageData.getTextById("lobby_combo_tournamentTyp_1");
        this._tf_table.text = Poker2Model.languageData.getTextById("lobby_tour_name");
    }

    public fillButtonLabels(vo: TeaserTextsVO = null): void {
        var textVO: TeaserTextsVO = (vo == null) ? this._teaserVO.teaserTextsVO : vo;

        this._btnOk.label = textVO.btnOkLabel;
        this._btnShop.label = textVO.btnShopLabel;
    }
}
classImplementsInterfaces(XmasTeaser, "Container");
